import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterLink } from "@angular/router";
import { LucideAngularModule } from "lucide-angular";
import { MatTableModule } from "@angular/material/table";
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        RouterLink,
        LucideAngularModule,
        FormsModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatTooltipModule,
        GoogleMapsModule,
        MatTableModule,
        NgbRatingModule,
        MatIconModule
    ],
    exports: [
        CommonModule,
        RouterLink,
        LucideAngularModule,
        FormsModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatTooltipModule,
        GoogleMapsModule,
        MatTableModule,
        NgbRatingModule,
        MatIconModule
    ]
})
export class CommonExternalModule {
}